
// 普通任务二=>普通任务 crowd api

import { http, https } from '../../global/axios';
import { PAGINATION_PARAM } from '../../global/constants';


// 做题信息统计

export const logs = (params) => {
  return http.post(`v2/tags/task/user/statistics.json`, params);
};

// 考核用户列表

export const checkUsers = (params = {
  ...PAGINATION_PARAM,
  gid: '',
  uid: ''
}) => {
  return http.post(`v1/tags/study/uc.json?gid=${params.gid}${params.uid ? '&uid=' + params.uid : ''}`);
};

// 获取任务来源及其他数据 原tags 普通任务一里的api

export const getFromType = (params) => {
  return http.post(`v1/tags/study/detail.json?gid=${params.gid}`);
};

// 重做获取token

export const getToken = (params) => {
  return https.post(`v2/tags/third/platform/token.json?type=${params.type}`);
};

// 考核 经验值验证

export const validate = (params) => {
  return https.post(`v2/tags/lib/validate.json?id=${params.id}`);
};

// 协议验证

export const getValidate = (params) => {
  return https.post(`v2/tags/task/validate/${params.id}.json`);
};

// 签署协议

export const taskSign = (params) => {
  return https.post(`v2/tags/task/sign/${params.id}.json`);
};

// 获取质检任务列表

export const qcList = (params) => {
  return http.post(`v2/tags/lib/check/qc/list.json`, params);
};

// 质检列表通过、不通过、重做

export const qcOperation = (type, params) => {
  return https.post(`v2/tags/lib/check/qc/answer/${type}.json`, params);
};

// 全部质检列表通过、不通过、重做

export const qcOperationAll = (params) => {
  return https.get(`v2/tags/lib/check/qc/all/${params.mid}/${params.operation}.json`);
};

// 获取质检任务列表展开信息

export const qcItemLogs = (params) => {
  return http.post(`v2/tags/lib/check/qc/logs.json`, params);
};

// 质检不通过 并设定作弊

export const qcCheat = (params) => {
  return https.post(`v2/tags/cheat/submit.json`, params);
};

// 获取优先重做列表

export const qcRedos = (params) => {
  return http.post(`v2/tags/lib/audit_new/redos.json`, params);
};
